import http from './http';

const getSmartSearchFilters = async ({ companyId, ...params }) => {
  const url = `casino/admin/companies/${companyId}/filters`;

  return http.get(url, { params }).then((res) => res.data);
};

const getSmartSearchFeatureTypes = async () => {
  const url = 'casino/admin/filters/types';

  return http.get(url).then((res) => res.data);
};

const editSmartSearchFilter = async ({ companyId, id, payload }) => {
  const url = `casino/admin/companies/${companyId}/filters/${id}`;

  return http.put(url, payload).then((res) => res.data);
};

const createSmartSearchFilter = async ({ companyId, payload }) => {
  const url = `casino/admin/companies/${companyId}/filters`;

  return http.post(url, payload).then((res) => res.data);
};

const deleteSmartSearchFilter = async ({ companyId, id }) => {
  const url = `casino/admin/companies/${companyId}/filters/${id}`;

  return http.delete(url).then((res) => res.data);
};

const updateSmartSearchFiltersOrder = async ({ companyId, payload }) => {
  const url = `casino/admin/companies/${companyId}/filters/order`;

  return http.patch(url, payload);
};

export default {
  getSmartSearchFilters,
  getSmartSearchFeatureTypes,
  editSmartSearchFilter,
  createSmartSearchFilter,
  deleteSmartSearchFilter,
  updateSmartSearchFiltersOrder,
};
